import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextBoolean from "components/text/TextBoolean";
import TextAmount from 'components/text/TextAmount';
import TextPercent from 'components/text/TextPercent';
import TextNumber from 'components/text/TextNumber';
import TransactionKey from 'calculator/components/TransactionKey';
import TextCalculatedFor from 'calculator/components/TextCalculatedFor';


const PaymentResultList = ({ data }) => {
    const [showPayments, setShowPayments] = useState(false); 

    let payments = data;
    return (
    <div className="calc-setting-table">
    <table className="table">
        <colgroup>
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        </colgroup>
        <thead>
        <tr>
        <th colSpan="13" className="text-left">
            <span className="calc-setting-table-header">Innborganir sem voru notaðar í útreikningum&nbsp;&nbsp;&nbsp;&nbsp;</span> 
            {/* <input id="checkCostid1" type="checkbox" checked={this.state.showPayments} onChange={this.showshowPaymentsClick}/><label className="calc-small-checkbox-label" htmlFor="checkCostid1" >Sýna greiðslur</label> */}
        </th>
        </tr>
        <tr>
        <th className="text-left">Reiknað f.</th>
        <th className="text-left">Færsl.nr.</th>
        <th className="text-left">Færslulykill</th>
        <th className="text-right">Dagsetning</th>
        <th className="text-right">Innborgun</th>
        <th className="text-right">Óráðstafað</th>

        <th className="text-right">Höfuðst.</th>
        <th className="text-right">Vísit.</th>
        <th className="text-right">Samningsv.</th>
        <th className="text-right">Drv.</th>
        <th className="text-right">Hst.Drv</th>
        <th className="text-right">VSK</th>
        <th className="text-right">FTS</th>

        </tr>
        </thead>
        <tbody>
        {payments.map((item,i) => {
        return(
            <tr key={i + "inner"}>
                <td className="text-left"><TextCalculatedFor data={item.calculatedFor}/></td>
                <td className="text-left"><TextNumber value={item.transactionNumber}/></td>
                <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                <td className="text-right"><TextDate value={item.paymentDate}/></td>
                <td className="text-right"><TextAmount value={item.amount}/></td>
                <td className="text-right"><TextAmount value={item.amountRemaining}/></td>
                <td className="text-right"><TextAmount value={item.paidCapital}/></td>
                <td className="text-right"><TextAmount value={item.paidIndex}/></td>
                <td className="text-right"><TextAmount value={item.paidContractInterest}/></td>
                <td className="text-right"><TextAmount value={item.paidPennaltyInterest}/></td>
                <td className="text-right"><TextAmount value={item.paidCapitalizedPennaltyInterest}/></td>
                <td className="text-right"><TextAmount value={item.paidVAT}/></td>
                <td className="text-right"><TextAmount value={item.paidCapitalGainsTax}/></td>
            </tr>);
        })}
        </tbody>
    </table>
    </div>
    );
  
}

PaymentResultList.propTypes = {
  data: PropTypes.array,
};



export default PaymentResultList;
